import API from "@src/API.js";
import { appearanceModeFromPerson, applyAndStoreAppearanceMode } from "../../theme/appearance";

const UserData = {
   User() {
      return JSON.parse(window.sessionStorage.getItem("UserId"));
   },

   UserData() {
      return JSON.parse(window.sessionStorage.getItem("UserData")) || {};
   },

   RecruitData() {
      return JSON.parse(window.sessionStorage.getItem("RecruitData")) || {};
   },

   Lookups() {
      return JSON.parse(window.sessionStorage.getItem("Lookups"));
   },

   async internalSaveAsync(type, obj) {
      if (obj.constructor === Object && Object.keys(obj).length === 0)
         return Promise.resolve({ result: "Success", obj: {} });
      var data = this.UserData();
      var msg = "";
      if (Array.isArray(obj)) {
         data[type] = obj;
         window.sessionStorage.setItem("UserData", JSON.stringify(data));
         return Promise.resolve({ result: "Success", obj: obj });
      }
      if (obj.hasOwnProperty("ID")) {
         if (data[type]) {
            var index = data[type].findIndex((c) => c.ID === obj.ID);
            console.log("index", index);
            console.log("element", data[type]);
            if (index >= 0) data[type][index] = obj;
            else data[type].push(obj);
            if ((obj.hasOwnProperty("tempID") && obj.tempID < 0)) {
               index = data[type].findIndex((c) => c.ID === obj.tempID);
               if (index >= 0) data[type].splice(index, 1);
            }

            window.sessionStorage.setItem("UserData", JSON.stringify(data));
            return Promise.resolve({ result: "Success", obj: obj });
         } else {
            msg = "UserData does not contain property called " + type;
            console.error(msg);
            debugger;
            return Promise.resolve({ result: "Error", message: msg });
         }
      }
      return Promise.resolve({ result: "Error", message: "Object has no ID property" });
   },

   async SaveToServerAsync(objectType, obj) {
      // var user = JSON.parse(localStorage.getItem("User"));

      var ret = { messages: [] };
      var url = "";
      switch (objectType.toLowerCase()) {
         case "connections":
            url = "/PostConnection";
            break;
         case "careers":
            url = "/PostCareer";
            break;
         case "skills":
            url = "/Skill";
            break;
         case "personskills":
            url = "/PostPersonSkill";
            break;
         case "employmenthistory":
            url = "/PersonEmployment";
            break;
         case "locations":
            url = "/PostLocation";
            break;
         case "contactinfos":
            url = "/PostContactInfo";
            break;
         case "certifications":
            url = "/Certification";
            break;
         case "education":
         case "educations":
            url = "/Education";
            break;
         case "employers":
            url = "/Employer";
            break;
         case "employerpreferences":
            url = "/Employer/Prefs";
            break;
         default:
            ret.messages.push("Unable to save object. Unknown object type:" + objectType);
            debugger;
            break;
      }
      if (url.length > 0) {
         let prevID;
         if (obj.ID < 0) {
            prevID = obj.ID;
            obj.ID = 0;
         }
         var resp = await API.postAsync(url, obj);
         if (resp && resp.ok && resp.jsonData) {
            var payload = resp.jsonData;
            var id = obj.ID || payload.ID || payload.id || (typeof payload === "number" ? payload : 0);
            if (!id) {
               ret.messages.push(
                  "Server method " + url + " did not return the id of the new object. It returned " + id
               );
            }
            obj.ID = id;
            obj.tempID = id;
         } else {
            console.log("Error: " + (resp && resp.message));
         }
         return resp;
      }
   },

   async UpdateAsync(type, obj, save = false) {
      if (!obj) {
         console.error("Update passed an invalid object to save.");
         return { result: "Error", message: "Invalid object", ok: false };
      }
      if (save) {
         const saveResp = await this.SaveToServerAsync(type, obj);
         if (saveResp && saveResp.ok) {
            const local = await this.internalSaveAsync(type, obj);
            return { ...local, ok: true, saveResp };
         }
         return {
            result: "Error",
            message: saveResp?.message || "Server save failed",
            ok: false,
            saveResp,
         };
      }
      return await this.internalSaveAsync(type, obj);
   },

   /** Alias used by older edit forms; prefer UpdateAsync. */
   Update(type, obj, save = false) {
      return this.UpdateAsync(type, obj, save);
   },
   async DeleteAsync(objectType, obj) {
      // We try to get the server to delete the object, but if it fails we add it to the update queue.
      var userData = this.UserData();
      var msg = "";
      var id = 0;
      if (!isNaN(obj)) id = obj;
      else {
         if (!isNaN(obj.ID)) {
            id = obj.ID;
         } else {
            let msg =
               "Unable to delete object because you didn't pass in the ID or the object you passed doesn't have an ID property";
            console.error(msg);
            return Promise.resolve({ result: false, warning: msg });
         }
      }
      if (id > 0) {
         // Now inform the server to delete it as well
         var resp = await API.postAsync("/DeleteObj", {
            ObjectType: objectType,
            ID: id,
         });
         if (resp && resp.ok) {
            console.info("Successfully deleted " + objectType + " with ID of " + id);
            return Promise.resolve({ result: true });
         } else {
            //this.pushChange({ objectType: objectType, action: 'Delete', obj: id });
            return Promise.resolve({ result: false, error: resp.message });
         }
      }
      return Promise.resolve({ result: true });
   },

   async GetUserDataAsync() {
      console.log("Retrieving User data");
      const resp = await API.getAsync("/Person/Account");
      if (resp && resp.ok) {
         console.log("Got User data", resp.jsonData);
         // Sort employment history by start date
         resp.jsonData.employmentHistory = resp.jsonData.employmentHistory.sort((a, b) => {
            return a.StartDate < b.StartDate ? 1 : -1;
         });
         window.sessionStorage.setItem("UserData", JSON.stringify(resp.jsonData));
         const serverMode = appearanceModeFromPerson(resp.jsonData?.person);
         if (serverMode) applyAndStoreAppearanceMode(serverMode);
         return resp;
      } else {
         console.error("Unable to retrieve User data");
      }
   },

   async GetLookupsAsync() {
      console.log("Retrieving Lookup data");

      const resp = await API.getAsync("/Lookups");
      if (resp && resp.ok) {
         console.log("Got Lookups", resp.jsonData);
         
         window.sessionStorage.setItem("Lookups", JSON.stringify(resp.jsonData));
         return resp.jsonData;
      } else {
         console.error("Unable to retrieve Lookups");
         debugger;
      }
   },

   Clear() {
      window.sessionStorage.clear();
   },
};

export default UserData;